// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface State {}
export namespace State {
  export const INITIAL: Readonly<State> = {}
}
